import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';

export const SUBSETTING_BASIC = 'basic';
export const SUBSETTING_CUSTOM = 'custom';
export const SUBSETTING_NONE = 'none';

export default createReactClass({
  propTypes: {
    subsetting: PropTypes.oneOf([SUBSETTING_BASIC, SUBSETTING_CUSTOM, SUBSETTING_NONE]),
    selectedCharacterSetIds: ImmutablePropTypes.set,
    characterSets: ImmutablePropTypes.list,
    onSubsettingChanged: PropTypes.func.isRequired,
    onCharacterSetChanged: PropTypes.func.isRequired,
  },

  mixins: [ImmutableRenderMixin],

  handleSubsettingChanged(event) {
    this.props.onSubsettingChanged(event.target.value);
  },

  handleCharacterSetChanged(event) {
    const id = parseInt(event.target.value, 10);
    const isChecked = event.target.checked;

    this.props.onCharacterSetChanged(id, isChecked);
  },

  renderCharacterSets() {
    if (this.props.subsetting !== SUBSETTING_CUSTOM) {
      return null;
    }

    const {
      characterSets,
    } = this.props;
    const characterSetElements = characterSets.map((characterSet, index) => {
      return (
        <div key={characterSet.id} className="col-xs-4">
          <div className="checkbox" key={index}>
            <label htmlFor="customSubsetting">
              <input
                className="check_boxes optional"
                type="checkbox"
                checked={this.props.selectedCharacterSetIds.includes(characterSet.id)}
                onChange={this.handleCharacterSetChanged}
                value={characterSet.id}
              /> {characterSet.name}
            </label>
          </div>
        </div>
      );
    });

    return (
      <div data-role="character-sets">
        {characterSetElements}
      </div>
    );
  },

  render() {
    const {subsetting} = this.props;

    return (
      <div>
        <div className="radio">
          <label>
            <input type="radio" name="basicSubsetting" value={SUBSETTING_BASIC} onChange={this.handleSubsettingChanged} checked={subsetting === SUBSETTING_BASIC} /> Basic Subsetting
            <p className="text-muted text-sm m-xs-b-0">English, French, German, Italian, Portuguese, and Spanish</p>
          </label>
        </div>
        <div className="radio">
          <label>
            <input type="radio" name="customSubsetting" value={SUBSETTING_CUSTOM} onChange={this.handleSubsettingChanged} checked={subsetting === SUBSETTING_CUSTOM} />Custom Subsetting
            <div className="text-sm text-muted m-xs-b-sm">Custom language support</div>
            <div className="row clearfix">
              {this.renderCharacterSets()}
            </div>
          </label>
        </div>
        <div className="radio">
          <label>
            <input type="radio" name="noSubsetting" value={SUBSETTING_NONE} onChange={this.handleSubsettingChanged} checked={subsetting === SUBSETTING_NONE} /> No Subsetting
          </label>
        </div>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/TypefaceSubsetting.js